import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetSalesImportsQueryResponse, GetSalesImportQueryResponse, SalesHoursDaysAllVM, TotalSalesHoursDaysVM } from "../../interfaces/interfaces";
import { AuthService } from 'src/app/services/auth.service';
import { MaintainWatchComponent } from '../maintain-watch/maintain-watch.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy, AggregateDescriptor, GroupDescriptor, GroupResult, aggregateBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user.service';
import { CreamsSalesDashClass } from '../creams-dash/creamsSalesDash';
import { groupBy } from "@progress/kendo-data-query";
import type { EChartsOption } from 'echarts';

interface Model {
  product: string;
  sales: number;
}

@Component({
  selector: 'sdc-general-dash-search-range',
  templateUrl: './general-dash-search-range.component.html',
  styleUrls: ['./general-dash-search-range.component.scss']
})
export class GeneralDashSearchRangeComponent implements OnInit {

  dateForm: UntypedFormGroup;
  userName: string;
  role: string;
  isLoading = false;
  canEdit = false;
  chosenWatch: GetSalesImportsQueryResponse;
  watches = [];
  watchTableDataSource = new MatTableDataSource<GetSalesImportsQueryResponse>();
  @ViewChild('watchTablePaginator') watchTablePaginator: MatPaginator;
  watchDisplayColumns: string[] = [
    'name', 'store', 'description', 'dateModified', 'imported', 'importDate', 'actions'];
  watchDisplayHeaders: Array<any> = [
    { key: 'name', header: 'File' },
    { key: 'store', header: 'Store' },
    { key: 'description', header: 'Description' },
    { key: 'dateModified', header: 'Upload Date' },
    { key: 'imported', header: 'Imported' },
    { key: 'importDate', header: 'Import Date' },
  ];

  day: string;
  month: string;
  year: string;


  //public gridData: SalesByYearVm[]; // | GroupResult[]; // Observable<any>;
  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public isNew: boolean;
  public watch: GetSalesImportQueryResponse;
  public sales: SalesHoursDaysAllVM;

  options: EChartsOption;

  mergeOptions: EChartsOption;

  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
  ) { }


  public gridStateTab1: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab2: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab3: State = {
    sort: [],
    skip: 0,
    take: 100,
  };


  tab1: TotalSalesHoursDaysVM[] = [];
  tab2: TotalSalesHoursDaysVM[] = [];
  tab3: TotalSalesHoursDaysVM[] = [];
  tab4: TotalSalesHoursDaysVM[] = [];


  public gridDataTab1: any = process(this.tab1, this.gridStateTab1);
  public gridDataTab2: any = process(this.tab2, this.gridStateTab2);
  public gridDataTab3: any = process(this.tab3, this.gridStateTab3);
 
  

  public aggregatesTab1: AggregateDescriptor[] = [
    { field: "nine", aggregate: "sum" },
    { field: "ten", aggregate: "sum" },
    { field: "eleven", aggregate: "sum" },
    { field: "twelve", aggregate: "sum" },
    { field: "thirteen", aggregate: "sum" },
    { field: "fourteen", aggregate: "sum" },
    { field: "fifteen", aggregate: "sum" },
    { field: "sixteen", aggregate: "sum" },
    { field: "seventeen", aggregate: "sum" },
    { field: "eighteen", aggregate: "sum" },
    { field: "nineTeen", aggregate: "sum" },
    { field: "twenty", aggregate: "sum" },
    { field: "twentyOne", aggregate: "sum" },
    { field: "twentyTwo", aggregate: "sum" },
    { field: "twentyThree", aggregate: "sum" },
    { field: "totalSales", aggregate: "sum" },
  ];
  public aggregatesTab2: AggregateDescriptor[] = [
    { field: "nine", aggregate: "sum" },
    { field: "ten", aggregate: "sum" },
    { field: "eleven", aggregate: "sum" },
    { field: "twelve", aggregate: "sum" },
    { field: "thirteen", aggregate: "sum" },
    { field: "fourteen", aggregate: "sum" },
    { field: "fifteen", aggregate: "sum" },
    { field: "sixteen", aggregate: "sum" },
    { field: "seventeen", aggregate: "sum" },
    { field: "eighteen", aggregate: "sum" },
    { field: "nineTeen", aggregate: "sum" },
    { field: "twenty", aggregate: "sum" },
    { field: "twentyOne", aggregate: "sum" },
    { field: "twentyTwo", aggregate: "sum" },
    { field: "twentyThree", aggregate: "sum" },
    { field: "totalSales", aggregate: "sum" },
  ];
  public aggregatesTab3: AggregateDescriptor[] = [
    { field: "nine", aggregate: "sum" },
    { field: "ten", aggregate: "sum" },
    { field: "eleven", aggregate: "sum" },
    { field: "twelve", aggregate: "sum" },
    { field: "thirteen", aggregate: "sum" },
    { field: "fourteen", aggregate: "sum" },
    { field: "fifteen", aggregate: "sum" },
    { field: "sixteen", aggregate: "sum" },
    { field: "seventeen", aggregate: "sum" },
    { field: "eighteen", aggregate: "sum" },
    { field: "nineTeen", aggregate: "sum" },
    { field: "twenty", aggregate: "sum" },
    { field: "twentyOne", aggregate: "sum" },
    { field: "twentyTwo", aggregate: "sum" },
    { field: "twentyThree", aggregate: "sum" },
    { field: "totalSales", aggregate: "sum" },
  ];

  public totalTab1Now: any = aggregateBy(this.gridDataTab1.data, this.aggregatesTab1);
  public totalTab2: any = aggregateBy(this.gridDataTab2.data, this.aggregatesTab2);
  public totalTab3: any = aggregateBy(this.gridDataTab3.data, this.aggregatesTab3);

  public seriesData: Model[] = [
    {
      product: "Chai",
      sales: 200,
    },
    {
      product: "Others",
      sales: 250,
    },
  ];

  ngOnInit(): void {

    /*const xAxisData = [];
    const data1 = [];
    const data2 = [];

    for (let i = 0; i < 100; i++) {
      xAxisData.push('category' + i);
      data1.push((Math.sin(i / 5) * (i / 5 - 10) + i / 6) * 5);
      data2.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5);
    }*/

    
  
    

    this.canEdit = true;
    this.userName = localStorage.getItem('currentUserName');
    this.dateForm = this.formBuilder.group({
      getDate: [null],
      getDateTo: [null],
    },);
    this.intialiseData();
  }

  intialiseData(): void {

    this.loadCreamsSales();

    this.options = {
      legend: {},
      tooltip: {},
      dataset: {
        // Provide a set of data.
        source: [
          ['product', 'Creams', 'MH', 'Dishd'],
          ['Test1', 43.3, 85.8, 93.7],
          ['Test2', 83.1, 73.4, 55.1],
          ['Test3', 86.4, 65.2, 82.5],
          ['Test4', 72.4, 53.9, 39.1],
        ],
      },
      // Declare an x-axis (category axis).
      // The category map the first column in the dataset by default.
      xAxis: { type: 'category' },
      // Declare a y-axis (value axis).
      yAxis: {},
      // Declare several 'bar' series,
      // every series will auto-map to each column by default.
      series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }],
    };
    
  }

  RandomDataset() {
    var sourceIn = [];
    sourceIn[0] = ['product', 'Creams', 'MH', 'Dishd'];
    for (let i = 1; i < this.sales.mh.length ; i++) {
      //text += cars[i] + "<br>";
      ///sourceIn[i] = [this.sales.mh[i].month.toString(), this.sales.tab2[i].creams, this.sales.tab2[i].mh, this.sales.tab2[i].dishd];
    }
    this.mergeOptions = {
      dataset: {
        source: sourceIn,
      },
    };
  }

  private loadCreamsSales(): void {

    this.authService.getHoursAndDaysSalesDash({useDay: 0}).pipe(take(1)).subscribe({
      next: (response: SalesHoursDaysAllVM) => {

        this.sales = response;

        this.gridDataTab1 = process(this.sales.creams, this.gridStateTab1);
        this.totalTab1Now = aggregateBy(this.gridDataTab1.data, this.aggregatesTab1);        
        this.gridDataTab2 = process(this.sales.mh, this.gridStateTab2);
        this.totalTab2 = aggregateBy(this.gridDataTab2.data, this.aggregatesTab2);
        this.gridDataTab3 = process(this.sales.dishd, this.gridStateTab3);
        this.totalTab3 = aggregateBy(this.gridDataTab3.data, this.aggregatesTab3);
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });

  }

  getDay(): void {
    // Clear existing data first
    this.sales = null;
    this.gridDataTab1 = { data: [], total: 0 };
    this.gridDataTab2 = { data: [], total: 0 };
    this.gridDataTab3 = { data: [], total: 0 };
    this.totalTab1Now = null;
    this.totalTab2 = null;
    this.totalTab3 = null;

    this.authService.getHoursAndDaysSalesDash({
      dayFrom: this.dateForm.controls.getDate.value, 
      dayTo: this.dateForm.controls.getDateTo.value 
    }).pipe(take(1)).subscribe({
      next: (response: SalesHoursDaysAllVM) => {
        this.sales = response;

        this.gridDataTab1 = process(this.sales.creams, this.gridStateTab1);
        this.totalTab1Now = aggregateBy(this.gridDataTab1.data, this.aggregatesTab1);        
        this.gridDataTab2 = process(this.sales.mh, this.gridStateTab2);
        this.totalTab2 = aggregateBy(this.gridDataTab2.data, this.aggregatesTab2);
        this.gridDataTab3 = process(this.sales.dishd, this.gridStateTab3);
        this.totalTab3 = aggregateBy(this.gridDataTab3.data, this.aggregatesTab3);

        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    alert("in day");
    //this.gridStateDay = state;
   // this.gridDataCurrentDay = process(this.sales.totalSalesByDate, this.gridStateDay);
       // this.totalDayOfWeek = aggregateBy(this.gridDataCurrentDay.data, this.aggregatesDay);
}

public dataStateChangeTab1(state: DataStateChangeEvent): void {
  alert("in tab1");
  //this.gridDataTab1 = state;
 // this.gridDataTab1 = process(this.sales.tab1, this.gridStateTab1);
        //this.totalTab1Now = aggregateBy(this.gridDataTab1, this.aggregatesTab1);
}

}
